import Vue from "vue";
import Vuex from "vuex";
import channel from "../scripts/_channel";
import profile from "../scripts/_profile";
import {
	createEmptyReservation
} from "../scripts/_reservation";
import registration from "../scripts/_registration";
import less from "less";
import validation from "../scripts/_validation";
Vue.use(Vuex);

const store = new Vuex.Store({
	state: () => ({
		channel,
		profile,
		reservation: createEmptyReservation(),
		registration: null,
		validationResult: {
			isValid: false,
			validationErrors: []
		},
	}),
	mutations: {
		setChannel(state, channel) {
			state.channel = channel;
		},
		setChannelLoaded(state, isLoaded) {
			state.channel.isLoaded = isLoaded;
		},
		setProfile(state, profile) {
			state.profile = profile;
		},
		setValidationResult(state, validationResult) {
			state.validationResult = validationResult;
		},
		initRegistration(state) {
			state.registration = registration;
		},
		setReservation(state, reservation) {
			state.reservation = reservation;
		}
	},
	actions: {
		setChannel({
			commit,
			dispatch
		}, channel) {
			commit("setChannel", channel);
			try {
				dispatch("setTheme");
			} catch {
				commit("setChannelLoaded", true);
			}
		},
		setProfile({
			commit
		}, profile) {
			commit("setProfile", profile);
		},
		setTheme({
			commit,
			state
		}) {

			//
			const addStyleTag = (css) => {
				const styleTag = document.createElement("style");
				styleTag.type = "text/css";
				styleTag.innerHTML = css;
				document.getElementsByTagName("head")[0].appendChild(styleTag);
				commit("setChannelLoaded", true);
			};

			//
			const defaultTheme = ".gradientCustom(@color0,@color1){background:@color0;background:-moz-linear-gradient(left,@color0 0%,@color1 100%);background:-webkit-linear-gradient(left,@color0 0%,@color1 100%);background:linear-gradient(to right,@color0 0%,@color1 100%);filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=@color0,endColorstr=@color1,GradientType=1);}.btn.btn-primary{&::after{.gradientCustom(@theme_color0,@theme_color1);}}.d21-switch .checkmark{.gradientCustom(@theme_color0,@theme_color1)}.d21-presset-days>div::after{.gradientCustom(@theme_color0,@theme_color1)}#d21-query #d21-query-header img{width:150px;}#d21-contact #d21-contact-header img{width:150px;}.header-picker{background-color:@theme_color0!important;}#d21-query #d21-query-shifts .vueperslides .vueperslide--active .vueperslide__content-wrapper{.gradientCustom(@theme_color0,@theme_color1);}";
			if (state.channel.Theme.UseDefaultTheme) {
				const colors = `@theme_color0:${state.channel.Theme.Colors.Color0};@theme_color1:${state.channel.Theme.Colors.Color1};`;
				const code = colors + defaultTheme;
				less.render(code, {}).then((output) => addStyleTag(output.css), (error) => console.log(error));
			} else if (state.channel.Theme.IsLess) {
				try {
					const code = state.channel.Theme.CssCode;
					less.render(code, {}).then((output) => addStyleTag(output.css), (error) => console.log(error));
				}
				catch (error) {
					const colors = `@theme_color0:${state.channel.Theme.Colors.Color0};@theme_color1:${state.channel.Theme.Colors.Color1};`;
					const code = colors + defaultTheme;
					less.render(code, {}).then((output) => addStyleTag(output.css), (error) => console.log(error));
				}
			} else {
				addStyleTag(state.channel.Theme.CssCode);
			}
		},
		validateReservation({
			state,
			commit
		}) {
			const result = validation.canCheckoutReservation(state.reservation, state.channel);
			commit("setValidationResult", result);
		},
		initRegistration({
			commit
		}) {
			commit("initRegistration");
		},
		resetReservation({
			commit,
			state
		}) {
			const reservation = createEmptyReservation();
			// keep profile infos and mode, reset the rest for now.
			reservation.Mode = state.reservation.Mode;
			reservation.ProfileInfos = state.reservation.ProfileInfos;
			reservation.Protection.Password = state.reservation.Protection.Password;

			commit("setReservation", reservation);
		}
	},
	getters: {
		canCheckout(state) {
			return state.validationResult.isValid;
		},
	}
});

export default store;